module.exports = __webpack_public_path__ + "static/media/images.21ecc04e.png";